// ── IMAGE SLOTS (Martial Arts Kids Class Ready, landing v2) ────────────────────────────
// v1 images live in the Impultienda store resources (Recursos). v2 images (5 volumes) are hosted on our own
// Higgsfield storage (cloudfront), so the store was not touched. All composited in code, no AI text.
const STORE = '2f1b33cd-1283-4de9-b23d-d22d221113ea';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;
const CDN = 'https://d2ol7oe51mr4n9.cloudfront.net/user_3DMFLKCotDruk7RKAWz1zy5qmH0/';

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. v2: the iMac screen shows the cover of the complete PDF
 * ("The Complete Year: 52 Ready-to-Teach Kids Classes in 5 Volumes") in the middle and the Vol. 02–05 covers on the sides.
 * v1 (cover + pages 4 and 8): RES + '1792611837302_mak-mockup-imac-a0b1c302.webp'
 */
const IMAC_V2 = CDN + '154a90fe-eaaa-43be-9526-4c2c8e0b2afc.webp';
export const heroMockupUrl = IMAC_V2;
export const offerMockupUrl = IMAC_V2;

/** The 5 volumes as books, fanned (transparent background), for the volumes section */
export const volumesFanUrl = CDN + '4834d57b-a9e3-4725-9713-177efaf833cb.webp';

/** The 5 volume covers (9:16), Vol. 01 → Vol. 05, for the volume tabs */
export const volumeCovers: string[] = [
  CDN + 'ffab0ceb-a288-4b3a-852f-410948a253da.webp',
  CDN + '6b3bd8f9-4ca0-4471-a14a-3133dce2c4f2.webp',
  CDN + '79ac3c9e-1203-4db4-941c-388f1c2cedd4.webp',
  CDN + '30f5cc97-345e-4c95-bba0-e7ec8a8de05f.webp',
  CDN + '40ea8895-7278-49c4-ab0f-890a8198f411.webp',
];

/** Real pages (9:16) of the complete PDF, same order as lookInside.captions. All checked letter by letter.
 *  The old Vol. 01 p.4 (plan with "10-minute game or drill" weeks) is replaced by the corrected plan page. */
export const pageImages: string[] = [
  CDN + '225e76d8-239d-46a1-93cc-de63baaeeef1.webp', // complete PDF p.2 · index of the 52 weeks
  CDN + '6ca5d31e-de53-4402-ad21-ce7cf0f8555a.webp', // Vol. 01 p.4 corrected · year plan Q1
  RES + '1792612197233_mak-pagina-11-clase-02-plan-11c623b7.webp', // Vol. 01 p.11 · week 5 plan
  RES + '1792612201539_mak-pagina-12-clase-02-teach-c7c4f20e.webp', // Vol. 01 p.12 · week 5 teach it
  RES + '1792612205874_mak-pagina-13-clase-02-drills-f278e2b7.webp', // Vol. 01 p.13 · week 5 drills & game
  CDN + 'e50117e8-b760-49a7-a683-e03178433439.webp', // Vol. 03 p.8 · week 15
  CDN + '3b865e4f-90ad-407a-97c9-b7f3c26954f1.webp', // Vol. 04 p.11 · week 29
  CDN + '3dc0bf07-f2a0-449f-b0cc-546b2598f561.webp', // Vol. 05 p.27 · week 49
  CDN + 'dd239018-d144-4563-99a7-9d1cf38b6b63.webp', // Vol. 05 p.2 · quarter 4
  RES + '1792612214849_mak-pagina-39-planner-10b1c578.webp', // Vol. 01 p.39 · planner
];

/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792611841876_mak-bono-1-juegos-f74409e6.webp',
  RES + '1792611845597_mak-bono-2-cinturon-bf90785e.webp',
  RES + '1792611849893_mak-bono-3-padres-3136d93b.webp',
  RES + '1792611853307_mak-bono-4-pads-acf98304.webp',
  RES + '1792611856876_mak-bono-5-prueba-a3ddb784.webp',
];
